import { render } from "./ProcessSteps.vue?vue&type=template&id=1b6ea5e0"
import script from "./ProcessSteps.vue?vue&type=script&lang=js"
export * from "./ProcessSteps.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__